/* eslint-disable no-unused-vars */
import api from '@/store/Api'

const dataLayer = {
  GetAdditionalImages: speciesId => {
    return new Promise((resolve, reject) => {
      api
        .get(`/LivetMisc/Livet/GetAdditionalImages/${speciesId}`)
        .then(function(response) {
          resolve(response)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  GetSpecLanInfo: () => {
    return new Promise((resolve, reject) => {
      api
        .get('/LivetMisc/Livet/GetSpecLanInfo')
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  GetLinksBySpecId: speciesId => {
    return new Promise((resolve, reject) => {
      api
        .get(`/LivetMisc/Livet/GetLinksBySpecId/${speciesId}`)
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  GetRelatedNewsBySpecName: speciesName => {
    return new Promise((resolve, reject) => {
      api
        .get(`/LivetMisc/Livet/GetRelatedNewsBySpecName/${speciesName}`)
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  //TODO
  GetRelatedAvhandlingarBySpecName: speciesName => {
    return new Promise((resolve, reject) => {
      api
        .get(`/LivetMisc/Livet/GetRelatedAvhandlingarBySpecName/${speciesName}`)
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  GetRelatedNewHavsutsiktBySpecName: speciesName => {
    return new Promise((resolve, reject) => {
      api
        .get(
          `/LivetMisc/Livet/GetRelatedNewHavsutsiktBySpecName/${speciesName}`
        )
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  },
  GetRelatedOldHavsutsiktBySpecName: speciesName => {
    return new Promise((resolve, reject) => {
      api
        .get(
          `/LivetMisc/Livet/GetRelatedOldHavsutsiktBySpecName/${speciesName}`
        )
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
          console.log(error)
        })
    })
  }
}
export default dataLayer
